/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import * as actionTypes from '../constants/action-types';
import { ReduxStateLoadable } from '@reducers/types';
import { MetricGroup } from '../types/metricGroup';
import { AnyAction } from 'redux';

type State = ReduxStateLoadable<MetricGroup[], MetricGroup[]> & { initiativeId: null | string };
const defaultState = {
  data: [],
  initiativeId: null,
  loaded: false,
  errored: false,
  errorMessage: ''
};

const customMetricGroups = (state: State = defaultState, action: AnyAction): State => {
  switch (action.type) {
    case actionTypes.LOADING_CUSTOM_METRIC_GROUPS:
      return { ...state, loaded: false, initiativeId: action.initiativeId, errored: false };
    case actionTypes.ERROR_CUSTOM_METRIC_GROUPS:
      return { ...state, loaded: true, errored: true, errorMessage: action.errorMessage };
    case actionTypes.LOADED_CUSTOM_METRIC_GROUPS:
      return {
        ...state,
        initiativeId: action.initiativeId,
        data: action.data,
        loaded: true,
        errored: false
      };
    default:
      return state;
  }
}

export default customMetricGroups;
